
export enum actionTypes {
    //FetchVideoGroups
    FETCH_CHEYCHEY_IAMGE_REQUEST = 'FETCH_CHEYCHEY_IAMGE_REQUEST',
    FETCH_CHEYCHEY_IAMGE_SUCCESS = 'FETCH_CHEYCHEY_IAMGE_SUCCESS',
    FETCH_CHEYCHEY_IAMGE_FAIL = 'FETCH_CHEYCHEY_IAMGE_FAIL',
    //CreateVideoGroup
    CREATE_CHEYCHEY_IAMGE_REQUEST = 'CREATE_CHEYCHEY_IAMGE_REQUEST',
    CREATE_CHEYCHEY_IAMGE_SUCCESS = 'CREATE_CHEYCHEY_IAMGE_SUCCESS',
    CREATE_CHEYCHEY_IAMGE_FAIL = 'CREATE_CHEYCHEY_IAMGE_FAIL',
    DELETE_CHEYCHEY_IAMGE_REQUEST = 'DELETE_CHEYCHEY_IAMGE_REQUEST',
    DELETE_CHEYCHEY_IAMGE_SUCCESS = 'DELETE_CHEYCHEY_IAMGE_SUCCESS',
    DELETE_CHEYCHEY_IAMGE_FAIL = 'DELETE_CHEYCHEY_IAMGE_FAIL',
}

export interface GenericGroupStateProps {
    isLoading: boolean;
    status: stateStatusType | null;
    error: string | null;
}

export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface GroupInput {
    name: string;
    description: string;
    group_order: number;
    imageFile?:File;
    image?:string
    icon?:string;
}
export interface GroupError {
    name?: string;
    group_order?:string;
    description?: string;
}

export interface CheyCheyImageProps {
     image: string;
     id: string;
}
export interface FetchCheyCheyImageRequestAction {
    type: actionTypes.FETCH_CHEYCHEY_IAMGE_REQUEST;
}

export interface FetchCheyCheyImageSuccessAction {
    type: actionTypes.FETCH_CHEYCHEY_IAMGE_SUCCESS;
    payload: CheyCheyImageProps[];
}

export interface FetchCheyCheyImageFailureAction {
    type: actionTypes.FETCH_CHEYCHEY_IAMGE_FAIL;
    payload: string;
}
//CreateVideoGroup
export interface CreateCheyCheyImageRequestAction {
    type: actionTypes.CREATE_CHEYCHEY_IAMGE_REQUEST;
}

export interface CreateCheyCheyImageSuccessAction {
    type: actionTypes.CREATE_CHEYCHEY_IAMGE_SUCCESS;
    payload: CheyCheyImageProps;
}
export interface CreateCheyCheyImageFailAction {
    type: actionTypes.CREATE_CHEYCHEY_IAMGE_FAIL;
    payload: string;
}
export interface DeleteCheyCheyImageRequestAction {
    type: actionTypes.DELETE_CHEYCHEY_IAMGE_REQUEST;
}

export interface DeleteCheyCheyImageSuccessAction {
    type: actionTypes.DELETE_CHEYCHEY_IAMGE_SUCCESS;
     payload: string;
}
export interface DeleteCheyCheyImageFailAction {
    type: actionTypes.DELETE_CHEYCHEY_IAMGE_FAIL;
    payload: string;
}

export type CheyCheyActions =
    | FetchCheyCheyImageRequestAction
    | FetchCheyCheyImageSuccessAction
    | FetchCheyCheyImageFailureAction
    | CreateCheyCheyImageRequestAction
    | CreateCheyCheyImageSuccessAction
    | CreateCheyCheyImageFailAction
    | DeleteCheyCheyImageRequestAction
    | DeleteCheyCheyImageSuccessAction
    | DeleteCheyCheyImageFailAction;
